import { t } from 'ttag'

import { appendSearchResults, initSearchResults } from './search'

import * as h2Api from '../h2Api'

export const JOB_LOADED = 'JOB_LOADED'
export const CLEAR_SELECTED = 'JOB_CLEAR_SELECTED'
export const RATE_JOB = 'RATE_JOB'
export const JOBSEARCH_HISTORY_LOADED = 'JOBSEARCH_HISTORY_LOADED'
export const JOBSEARCH_SEARCH_ITEMS = 'JOBSEARCH_SEARCH_ITEMS'
export const JOBSEARCH_COMPARISON_SET_ERROR = 'JOBSEARCH_COMPARISON_SET_ERROR'
export const JOBSEARCH_COMPARISON = 'JOBSEARCH_COMPARISON'
export const SELECT_JOB_FOR_COMPARISON = 'SELECT_JOB_FOR_COMPARISON'
export const REMOVE_JOB_FOR_COMPARISON = 'REMOVE_JOB_FOR_COMPARISON'
export const CLEAR_JOBSEARCH_COMPARISON = 'CLEAR_JOBSEARCH_COMPARISON'
export const ADD_JOBSEARCH_SEARCH_ITEMS = 'ADD_JOBSEARCH_SEARCH_ITEMS'

export const selectForComparison = id => (dispatch, getState) => {
  const comparisons = getState().jobs.comparison.selected.length

  console.log(id)

  if (comparisons == 4) {
    alert(t`You already have four items selected`)

    return false
  }

  return Promise.resolve(dispatch({ type: SELECT_JOB_FOR_COMPARISON, id }))
}

export const removeForComparison = id => dispatch => {
  return Promise.resolve(dispatch({ type: REMOVE_JOB_FOR_COMPARISON, id }))
}

export const compareJobs = jobs => dispatch => {
  const items = typeof jobs === 'string' ? [jobs] : jobs

  console.log(items, jobs)

  if (!items) {
    return Promise.resolve(
      dispatch({
        type: JOBSEARCH_COMPARISON_SET_ERROR,
        error: t`No jobs specified for comparison`
      })
    )
  }

  dispatch({
    type: JOBSEARCH_COMPARISON_SET_ERROR,
    error: null
  })

  return dispatch(
    h2Api.post('/profiles/jobopening/compare', { jobOpeningId: items })({
      type: JOBSEARCH_COMPARISON
    })
  )
}

export const clearJobComparison = () => dispatch => {
  return Promise.resolve(dispatch({ type: CLEAR_JOBSEARCH_COMPARISON }))
}

export const searchJobs = term => form => dispatch => {
  console.log('Received In Search Jobs:', form)
  const data = {
    term,
    filters: form
  }
  const jobSearchReturn = dispatch(
    h2Api.post(
      `/api/v1/profiles/jobopening/search`,
      data
    )({ type: JOBSEARCH_SEARCH_ITEMS })
  )

  jobSearchReturn.then(v => {
    console.log('APPENDING')
    dispatch(initSearchResults(v.results))
  })

  return jobSearchReturn
}

export const loadSubsequentJobsListing = (term, filters) => (
  startIdx,
  endIdx
) => dispatch => {
  const updatedJson = {
    term,
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(
      `/profiles/jobopening/search`,
      updatedJson
    )({ type: ADD_JOBSEARCH_SEARCH_ITEMS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}

export const loadJob = jobId => (dispatch, getState) => {
  dispatch({ type: CLEAR_SELECTED })

  return dispatch(h2Api.get(`/profiles/jobopening/${jobId}`)({ type: JOB_LOADED }))
}

export const loadJobHistory = () => (dispatch, getState) => {
  return dispatch(
    h2Api.get('/profiles/jobopening/history')({ type: JOBSEARCH_HISTORY_LOADED })
  )
}

export const rateJob = (job, ratingType) => dispatch => {
  console.log('RATING', job, ratingType)

  return dispatch(
    h2Api.put(`/user/rate/externaljobopening/${job.id}`, {
      rating: ratingType
    })({ type: RATE_JOB, id: job.id })
  )
}
